"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var Raven = __importStar(require("raven-js"));

var constants_generated_1 = require("./constants.generated");

function default_1() {
  var errorReporter = new Raven.Client();
  errorReporter.config('https://b072814aeada47dfa70b6b4ab327cb3b@sentry.io/1206884', {
    release: constants_generated_1.version,
    environment: process.env.NODE_ENV,
    autoBreadcrumbs: false,
    instrument: false,
    shouldSendCallback: function shouldSendCallback(err) {
      if (err && err.exception && err.exception.values && err.exception.values.length > 0 && err.exception.values[0].value && err.exception.values[0].value.indexOf('MEDIA_ERR_BLOCKED_AUTOPLAY')) {
        return false;
      }

      if (process.env.NODE_ENV === 'development') {
        // tslint:disable-next-line: no-console
        console.log('The following error would be sent to Sentry in production:'); // tslint:disable-next-line: no-console

        console.error(err);
        return false;
      } else {
        return true;
      }
    }
  });
  return errorReporter;
}

exports["default"] = default_1;